var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('br'),_c('br'),_c('br'),(!this.$store.state.isLoggedIn)?_c('NotLoggedIn'):_vm._e(),(this.$store.state.isLoggedIn && this.$store.state.isAdministrator)?_c('AdministratorDashboard'):_vm._e(),(
      this.$store.state.isLoggedIn &&
        !this.$store.state.isAdministrator &&
        this.$store.state.userIsEmployee
    )?_c('EmployeeDashboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }